export enum TAG_SIZE {
  xsmall = 'xsmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum TAG_STYLE {
  light = 'light',
  dark = 'dark',
  success = 'success',
  warning = 'warning',
  gold = 'gold',
  error = 'error',
  info = 'info',
  infoLight = 'info-light',
  accentRed = 'accent-red',
  accentPurple = 'accent-purple',
  accentGreen = 'accent-green',
  accentBlue = 'accent-blue',
  accentWarning = 'accent-warning',
  spruceGreen = 'spruce-green',
  plumPurple = 'plum-purple',
  disabled = 'disabled',
  errorDark = 'error-dark',
}
